import { drizzle as drizzle$1 } from "drizzle-orm/libsql";
import { b as building } from "./environment.js";
import { b as private_env } from "./shared-server.js";
import { drizzle } from "drizzle-orm/d1";
import { sqliteTable, integer, text, index } from "drizzle-orm/sqlite-core";
const user = sqliteTable("user", {
  id: text("id").primaryKey(),
  temp: integer("temp", { mode: "boolean" }).notNull(),
  email: text("email").unique(),
  service: text("service"),
  serviceId: text("service_id"),
  lastSeen: integer("last_seen", { mode: "timestamp" }).notNull(),
  createdAt: integer("created_at", { mode: "timestamp" }).notNull()
});
const magicLink = sqliteTable(
  "magic_link",
  {
    id: text("id").primaryKey(),
    userId: text("user_id").notNull().references(() => user.id),
    verification: text("verification").notNull(),
    expiresAt: integer("expires_at", { mode: "timestamp" }).notNull(),
    email: text("email").notNull()
  },
  (table) => ({
    expiresIdx: index("magic_expires_idx").on(table.expiresAt)
  })
);
const session = sqliteTable("session", {
  id: text("id").primaryKey(),
  userId: text("user_id").notNull().references(() => user.id),
  expiresAt: integer("expires_at", { mode: "timestamp" }).notNull()
});
const link = sqliteTable(
  "link",
  {
    id: text("id").primaryKey(),
    url: text("url").notNull(),
    passphrase: text("passphrase"),
    callLimit: integer("call_limit"),
    calls: integer("calls"),
    userId: text("user_id").notNull().references(() => user.id),
    createdAt: integer("created_at", { mode: "timestamp" }).notNull(),
    expiresAt: integer("expires_at", { mode: "timestamp" })
  },
  (table) => ({
    expiresIdx: index("link_expires_idx").on(table.expiresAt)
  })
);
const getDatabaseURL = () => {
  if (building) {
    return ":memory:";
  }
  if (!private_env.DATABASE_URL) {
    throw new Error("DATABASE_URL is not set");
  }
  return private_env.DATABASE_URL;
};
let db;
const createDatabase = () => {
  const type = private_env.DATABASE_TYPE?.toLowerCase() ?? "libsql";
  if (type === "d1") {
    return drizzle(private_env.SHRTN_D1);
  } else {
    return drizzle$1({
      connection: {
        url: getDatabaseURL(),
        authToken: private_env.DATABASE_AUTH_TOKEN
      }
    });
  }
};
const getDB = () => {
  if (!db) {
    db = createDatabase();
  }
  return db;
};
export {
  getDB as g,
  link as l,
  magicLink as m,
  session as s,
  user as u
};
